import { AtendimentoVacinacaoState } from '@atendimento/atendimento-vacinacao/model'
import { createValidator, required } from 'util/validation'

import { FinalizacaoAtendimentoFormModel } from '../soap/finalizacao/FinalizacaoAtendimentoForm'
import { agendarConsultaAvulsaValidator } from '../soap/finalizacao/validator/validator-agendamento'

export const atendimentoVacinacaoValidator = (
  canAccessAgenda: boolean,
  getServerTimeNow: () => Date,
  showGravidaPuerperaRadioField: boolean,
  showHorarioFinal: boolean
) =>
  createValidator<AtendimentoVacinacaoState>({
    finalizacaoVacinacao: createValidator<FinalizacaoAtendimentoFormModel>({
      agendamentoConsultas: canAccessAgenda
        ? agendarConsultaAvulsaValidator(getServerTimeNow, showHorarioFinal)
        : undefined,
    }),
    condicoesVacinacao: showGravidaPuerperaRadioField ? createValidator({ condicao: [required] }) : undefined,
  })
